// import { setValuesInternal } from '../framework/actions'
import { DARK_THEME } from '../framework/constants'
import { stateRef } from '../framework/store'

const setDarkMode = (_darkMode: boolean) => {
  // setValuesInternal({ theme: darkMode ? DARK_THEME : LIGHT_THEME })
  console.warn('setDarkMode is disabled, please use sparky way to override theme')
}

export function useDarkMode(
  enabled = true
): [boolean, (darkMode: boolean) => void] {
  const darkMode = Boolean(enabled && stateRef.current.theme === DARK_THEME)
  return [darkMode, setDarkMode]
}
